var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnedLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0827 37.5H0.916016",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9165 15.2499L37.2331 10.9165L36.0998 9.79988C35.6593 9.35189 35.134 8.99609 34.5545 8.75321C33.9751 8.51034 33.3531 8.38525 32.7248 8.38525C32.0965 8.38525 31.4745 8.51034 30.8951 8.75321C30.3156 8.99609 29.7903 9.35189 29.3498 9.79988C28.9058 10.2427 28.5536 10.7687 28.3133 11.3478C28.0729 11.927 27.9492 12.5479 27.9492 13.1749C27.9492 13.8019 28.0729 14.4228 28.3133 15.0019C28.5536 15.5811 28.9058 16.1071 29.3498 16.5499",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9836 15.2501L18.6836 10.9168L19.8169 9.80009C20.7363 9.05546 21.8998 8.67934 23.0811 8.74487C24.2624 8.81041 25.3771 9.31291 26.2084 10.1547C27.0398 10.9964 27.5284 12.1173 27.5793 13.2993C27.6301 14.4813 27.2396 15.64 26.4836 16.5501",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9492 20V37.5",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26667 12.0333C9.89923 12.0333 12.0333 9.89923 12.0333 7.26667C12.0333 4.63411 9.89923 2.5 7.26667 2.5C4.63411 2.5 2.5 4.63411 2.5 7.26667C2.5 9.89923 4.63411 12.0333 7.26667 12.0333Z",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7325 21.6668H37.4992V20.0001C37.4992 18.7359 36.997 17.5235 36.1031 16.6296C35.2092 15.7356 33.9967 15.2334 32.7325 15.2334C32.1052 15.2312 31.4836 15.3529 30.9033 15.5915C30.3231 15.83 29.7956 16.1808 29.3512 16.6236C28.9068 17.0665 28.5542 17.5927 28.3136 18.1721C28.0731 18.7515 27.9492 19.3727 27.9492 20.0001V21.6668",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1827 21.6667H18.416V20.0001C18.416 18.7359 18.9182 17.5234 19.8121 16.6295C20.7061 15.7356 21.9185 15.2334 23.1827 15.2334C24.4469 15.2334 25.6593 15.7356 26.5532 16.6295C27.4472 17.5234 27.9494 18.7359 27.9494 20.0001V21.6667",
    stroke: "#3B82F6",
    strokeWidth: 2.8,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnedLeave);
export default __webpack_public_path__ + "static/media/earnedLeave.2eae62b3bc944d596ff5d259653e061d.svg";
export { ForwardRef as ReactComponent };